export const AUTH_LEVELS = {
  SUPER_ADMIN: 0,
  ORG_ADMIN: 100,
  ORG_MANAGER: 150,
  ADMIN: 200,
  ORG_USER: 300,
  USER: 400,
  PORTAL_USER: 400,
  NO_PORTAL_ACCESS: 500,
  ALL_USER: 1000,
};
